/**
 * オンボーディングステップ定義
 * 各使用目的に応じたステップを定義
 */

export const onboardingSteps = {
  // 測量関係
  survey: [
    {
      targetSelector: '#layer-selection-btn',
      message: 'まず、地図レイヤーを選択しましょう。測量には「基盤地図情報」や「空中写真」がおすすめです。',
      position: 'right',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="traverse-menu"]',
      message: 'トラバース機能はここから開始できます。測量データの入力と計算が可能です。',
      position: 'right',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="session-menu"]',
      message: 'セッション機能を使うと、作業の保存と共有が簡単にできます。',
      position: 'right',
      actionRequired: false,
    },
  ],

  // 一般
  general: [
    {
      targetSelector: '#layer-selection-btn',
      message: 'ここをクリックして、表示したい地図レイヤーを選択できます。',
      position: 'right',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="toolbar"]',
      message: 'このツールバーから、距離測定や図形描画などの便利な機能が使えます。',
      position: 'bottom',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="myroom"]',
      message: 'マイルームでは、保存した地図や設定を管理できます。',
      position: 'right',
      actionRequired: false,
    },
  ],

  // 古地図
  'old-map': [
    {
      targetSelector: '#layer-selection-btn',
      message: '古地図を見るには、まずレイヤー選択ボタンをクリックします。',
      position: 'right',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="old-map-category"]',
      message: '「古地図」カテゴリから、時代別の地図を選択できます。現代の地図と比較してみましょう！',
      position: 'left',
      actionRequired: false,
    },
    {
      targetSelector: '[data-onboarding="opacity-slider"]',
      message: '透明度スライダーで、古地図と現代地図を重ね合わせて比較できます。',
      position: 'bottom',
      actionRequired: false,
    },
  ],
}

/**
 * ステップの総数を取得
 */
export function getTotalSteps(purpose) {
  return onboardingSteps[purpose]?.length || 0
}

/**
 * 特定のステップを取得
 */
export function getStep(purpose, stepIndex) {
  const steps = onboardingSteps[purpose]
  if (!steps || stepIndex < 0 || stepIndex >= steps.length) {
    return null
  }
  return steps[stepIndex]
}

/**
 * 次のステップがあるかチェック
 */
export function hasNextStep(purpose, currentStepIndex) {
  const steps = onboardingSteps[purpose]
  return steps && currentStepIndex < steps.length - 1
}
